export default {
	change_password: "Alterar Senha",
	control_pannel: "Painel de Controle",
	idiom: "Idioma",
	messages: "Mensagens",
	my_profile: "Meu Perfil",
	no_notification_available: "Nenhuma notificação disponível",
	no_notifications_avaliable: "Sem notificações disponíveis",
	sign_out: "Sair"
}